import './Tabs.css';

export function Tabs({ items = [], onChange }) {
  return (
    <div className="page-tabs" role="tablist">
      {items.map((item, i) => {
        const locked = item.prox || item.disabled;
        return (
          <button
            key={item.label}
            role="tab"
            aria-selected={item.active}
            aria-disabled={locked || undefined}
            className={`ptab${item.active ? ' active' : ''}${
              locked ? ' ptab--locked' : ''
            }`}
            onClick={() => !locked && onChange && onChange(i, item)}
            tabIndex={locked ? -1 : 0}
            type="button"
          >
            {item.label}
            {item.prox ? (
              <span className="ptab__prox">PROX</span>
            ) : (
              item.count != null && <span className="count">{item.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
